import React, { FC, ReactElement } from "react";
import { Redirect } from "react-router-dom";

import { RouteEnum } from "core/enum/route.enum";
import { UserRoles } from "core/enum/user-roles.enum";
import { useSelectUserRoles } from "store/auth/auth.selectors";

interface IProps {
  roles?: UserRoles[];
  children: ReactElement;
}

export const RoleGuard: FC<IProps> = ({ roles, children }) => {
  const userRoles = useSelectUserRoles();

  const hasAccess = roles?.some((role) => userRoles?.includes(role));

  if (!hasAccess) return <Redirect to={RouteEnum.Error403} />;

  return children;
};
